import moment from 'moment'
export const deleteCookie = name => {
    document.cookie = `${name}=;path=/;expires=${moment(-1).toString()}`
}
